import { __ } from "./translates.js";
const isResponseValidationError = (error) => {
  return typeof error.validation === "string" || typeof error.validation === "object" && Object.keys(error.validation).length > 0;
};
const isResponseErrorWithMessages = (error) => {
  return typeof error.messages !== "undefined";
};
const isResponseErrorWithMessage = (error) => {
  return typeof error.message !== "undefined" && typeof error.response === "undefined";
};
const isResponseErrorWithDataMessages = (error) => {
  var _a;
  return typeof ((_a = error.data) == null ? void 0 : _a.messages) !== "undefined";
};
const isResponseNotificationError = (error) => {
  return typeof error.notification !== "undefined" && error.notification != null;
};
const isResponseRawError = (error) => {
  const { data, message } = error.response || {};
  return typeof data !== "undefined" || typeof message === "string";
};
const isResponseErrorWithDataMessage = (error) => {
  return typeof error.data === "string";
};
const getResponseMessage = (error, defaultMessage = null) => {
  if (isResponseValidationError(error)) {
    const { params = {} } = error;
    if (typeof error.validation === "string") {
      return __(error.validation, params);
    }
    if (typeof error.validation === "object") {
      const messages = error.validation;
      return __(Object.values(messages)[0], params);
    }
  }
  if (isResponseErrorWithDataMessages(error)) {
    let { data: { messages, ...params } } = error;
    if (typeof messages !== "string") {
      messages = messages[0] || Object.values(messages)[0];
    }
    let messageParams = params;
    if ("data" in error.data) {
      messageParams = error.data.data;
    }
    return __(messages, messageParams);
  }
  if (isResponseErrorWithMessages(error)) {
    const { messages, ...params } = error;
    if (typeof messages === "string") {
      return __(messages, params);
    }
    return messages[0] || Object.values(messages)[0];
  }
  if (isResponseErrorWithMessage(error)) {
    return error.message;
  }
  if (isResponseNotificationError(error)) {
    return error.notification.message ?? null;
  }
  if (isResponseRawError(error)) {
    const { data, message } = error.response;
    if (typeof data === "object" && Object.keys(data)) {
      if (data.message) {
        return data.message;
      }
      if (Object.keys(data).length) {
        return Object.values(data);
      }
      if (typeof message === "object") {
        return __(message.message, message.params);
      }
    }
    if (typeof data === "string") {
      return data;
    }
    if (typeof message === "string") {
      return message;
    }
  }
  if (isResponseErrorWithDataMessage(error)) {
    return error.data;
  }
  return defaultMessage;
};
export {
  getResponseMessage
};
